import React from "react";

function DownloadIcon() {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5 10.625V15.625C17.5 15.7908 17.4342 15.9497 17.3169 16.0669C17.1997 16.1842 17.0408 16.25 16.875 16.25H3.125C2.95924 16.25 2.80027 16.1842 2.68306 16.0669C2.56585 15.9497 2.5 15.7908 2.5 15.625V10.625C2.5 10.4592 2.56585 10.3003 2.68306 10.1831C2.80027 10.0658 2.95924 10 3.125 10C3.29076 10 3.44973 10.0658 3.56694 10.1831C3.68415 10.3003 3.75 10.4592 3.75 10.625V15H16.25V10.625C16.25 10.4592 16.3158 10.3003 16.4331 10.1831C16.5503 10.0658 16.7092 10 16.875 10C17.0408 10 17.1997 10.0658 17.3169 10.1831C17.4342 10.3003 17.5 10.4592 17.5 10.625ZM9.55781 11.0672C9.61586 11.1253 9.68479 11.1714 9.76066 11.2029C9.83654 11.2343 9.91787 11.2505 10 11.2505C10.0821 11.2505 10.1635 11.2343 10.2393 11.2029C10.3152 11.1714 10.3841 11.1253 10.4422 11.0672L13.5672 7.94219C13.6253 7.88412 13.6713 7.81518 13.7027 7.73931C13.7342 7.66344 13.7503 7.58212 13.7503 7.5C13.7503 7.41788 13.7342 7.33656 13.7027 7.26069C13.6713 7.18482 13.6253 7.11588 13.5672 7.05781C13.5091 6.99974 13.4402 6.95368 13.3643 6.92225C13.2884 6.89083 13.2071 6.87465 13.125 6.87465C13.0429 6.87465 12.9616 6.89083 12.8857 6.92225C12.8098 6.95368 12.7409 6.99974 12.6828 7.05781L10.625 9.11641V1.875C10.625 1.70924 10.5592 1.55027 10.4419 1.43306C10.3247 1.31585 10.1658 1.25 10 1.25C9.83424 1.25 9.67527 1.31585 9.55806 1.43306C9.44085 1.55027 9.375 1.70924 9.375 1.875V9.11641L7.31719 7.05781C7.19991 6.94054 7.04085 6.87465 6.875 6.87465C6.70915 6.87465 6.55009 6.94054 6.43281 7.05781C6.31554 7.17509 6.24965 7.33415 6.24965 7.5C6.24965 7.66585 6.31554 7.82491 6.43281 7.94219L9.55781 11.0672Z"
          fill="#2F80ED"
        />
      </svg>
    </>
  );
}

export default DownloadIcon;
